export const getMpTrackingUrl = (orderNumber: string): string => {
  const regionUrlMap: Record<number, string> = {
    0: window.CARTNG_R0_URL,
    1: window.CARTNG_R1_URL,
    2: window.CARTNG_R2_URL,
  };

  const regex = /^WM(\d)/;
  const match = regex.exec(orderNumber);

  if (match) {
    const numericRegion = Number(match[1]);
    const url = regionUrlMap[numericRegion];
    return `${url}/api`;
  }
  return '';
};
